import { create } from "zustand";
import { persist } from "zustand/middleware";
import { api } from "./api";

export const useAuthStore = create(
    persist(
        (set, get) => ({
            token: null,
            user: null,
            hydrated: false,
            setHydrated: () => set({ hydrated: true }),
            login: (token, user) => {
                localStorage.setItem("rk_token", token);
                set({ token, user });
            },
            logout: () => {
                localStorage.removeItem("rk_token");
                set({ token: null, user: null });
            },
            fetchMe: async () => {
                try {
                    const r = await api.get("/auth/me");
                    set({ user: r.data });
                    return r.data;
                } catch {
                    get().logout();
                    return null;
                }
            },
        }),
        { name: "rk_auth" }
    )
);

export const useCartStore = create(
    persist(
        (set, get) => ({
            items: [], // { brand_id, sku, brand_name, logo_url, category, denomination, quantity, discount_percentage, key }
            addItem: (item) => {
                const items = get().items;
                const key = `${item.brand_id}-${item.denomination}`;
                const idx = items.findIndex((i) => i.key === key);
                if (idx >= 0) {
                    const next = [...items];
                    next[idx] = { ...next[idx], quantity: Math.min(50, next[idx].quantity + item.quantity) };
                    set({ items: next });
                } else {
                    set({ items: [...items, { ...item, key }] });
                }
            },
            updateQty: (key, quantity) => {
                const items = get().items.map((i) =>
                    i.key === key ? { ...i, quantity: Math.max(1, Math.min(50, quantity)) } : i
                );
                set({ items });
            },
            removeItem: (key) => set({ items: get().items.filter((i) => i.key !== key) }),
            clear: () => set({ items: [] }),
            totalListPrice: () =>
                get().items.reduce((acc, i) => acc + i.denomination * i.quantity, 0),
            totalPayable: () =>
                get().items.reduce(
                    (acc, i) =>
                        acc +
                        i.denomination * i.quantity * (1 - (i.discount_percentage || 0) / 100),
                    0
                ),
            totalSavings: () => get().totalListPrice() - get().totalPayable(),
            count: () => get().items.reduce((acc, i) => acc + i.quantity, 0),
        }),
        { name: "rk_cart" }
    )
);

export const useUIStore = create((set) => ({
    loginOpen: false,
    cartOpen: false,
    setLoginOpen: (v) => set({ loginOpen: v }),
    setCartOpen: (v) => set({ cartOpen: v }),
}));
